const profile = {
  title: "Mi perfil",
  premiumBtn: "Ir a premium",
  orderInfoTitle: "Información sobre el permiso de la cuenta.",
  tableProduct: "Producto",
  tableStatus: "Estado",
  tablePermissionDate: "Fecha del permiso",
  tableValidPeriod: "Período de validez",
  validStauts: "Válido",
  expiredStauts: "Caducado",
  noData: "Sin datos",
};

export default profile;
